$(function(){

  // ドメイン設定
  var url = $( location ).attr( 'href' );
  var api_domain = '';
  if( url.indexOf('localhost' ) > -1 ){
    api_domain = 'http://localhost:3001';
  } else if ( url.indexOf('test' ) > -1 ) {
    api_domain = 'https://test.api.osouji.support';
  } else {
    api_domain = 'https://api.osouji.support';
  }

  //都道府県を選択
  $( '[name="enduser[prefecture_id]"]' ).change(function() {
    var $this = $( this )
    var val = $this.val();

    $.ajax({
      type: 'POST',
      url: api_domain + '/v1/areas/city_list',
      data: { prefecture_id: val },
      dataType : 'json',
      headers: {
        'Authorization':'bearer ' + gon.authorize_code
      }
    }).done(function (response) {
      if ( response.status == "success" ) {
        var option_value = '<option value="">市区町村を選択してください</option>';

        // 町名を打ち消し
        $this.closest( 'form' ).find( '[name="enduser[area_id]"]' ).html( '<option value="">町名を選択してください</option>' );
        $.each(response.data.city, function(i, row){
          option_value += '<option value="' + row.city_id + '">' + row.city_name + '</option>'
        })

        $this.closest( 'form' ).find( '[name="enduser[city_cd]"]' ).html( option_value );
      } else {

      }
    });
  });

  //市区町村を選択
  $( '[name="enduser[city_cd]"]' ).change(function() {
    var $this = $( this )
    var val = $this.val();

    var prefecture_value = $( '[name="enduser[prefecture_id]"]' ).val();
    $.ajax({
      type: 'POST',
      url: api_domain + '/v1/areas/area_list',
      data: { 
        prefecture_id: prefecture_value,
        city_id: val
      },
      dataType : 'json',
      headers: {
        'Authorization':'bearer ' + gon.authorize_code
      }
    }).done(function (response) {
      if ( response.status == "success" ) {
        var option_value = '<option value="">町名を選択してください</option>';
        $.each(response.data.area, function(i, row){
          option_value += '<option value="' + row.id + '">' + row.area_name + '</option>'
        })

        $this.closest( 'form' ).find( '[name="enduser[area_id]"]' ).html( option_value );
      } else {

      }
    });
  });

  //町名を選択
  $( '[name="enduser[area_id]"]' ).change(function() {
    var $this = $( this )
    var val = $this.val();

    var prefecture_value = $( '[name="enduser[prefecture_id]"]' ).val();
    var city_value = $( '[name="enduser[city_cd]"]' ).val();
    $.ajax({
      type: 'POST',
      url: api_domain + '/v1/areas/get_zipcode',
      data: { 
        prefecture_id: prefecture_value,
        city_id: city_value,
        area_id: val
      },
      dataType : 'json',
      headers: {
        'Authorization':'bearer ' + gon.authorize_code
      }
    }).done(function (response) {
      if ( response.status == "success" ) {
        $( '[name="enduser[zipcode]"]' ).val( response.data.zipcode );
        $( '#label_address' ).text( response.data.prefecture_name + response.data.city_name + response.data.area_name )
      } else {

      }
    });
  });

  $( '[name="enduser[zipcode]"]' ).keyup(function() {
    var $this = $( this );
    $this.val( $this.val().replace( /-/g, '' ).replace( /ー/g, '' ).replace( /−/g, '' ).replace( /―/g, '' ).replace( /‐/g, '' ) );
  });

  // 郵便番号を入力
  $( '[name="enduser[zipcode]"]' ).change(function() {
    var $this = $( this );
    var val = $this.val();

    $.ajax({
      type: 'POST',
      url: api_domain + '/v1/areas/get_address',
      data: { 
        zipcode: val
      },
      dataType : 'json',
      headers: {
        'Authorization':'bearer ' + gon.authorize_code
      }
    }).done(function (response) {
      if ( response.status == "success" ) {
        // 住所表示
        $( '#label_address' ).text( response.data.selected.prefecture_name + response.data.selected.city_name + response.data.selected.area_name ).show();

        // 都道府県設置
        $this.closest( 'form' ).find( '[name="enduser[prefecture_id]"]' ).find( 'option[value="' + response.data.selected.prefecture_id + '"]' ).prop('selected', true);

        //市区町村設置
        var option_value = '<option value="">市区町村を選択してください</option>';
        $.each(response.data.city_list, function(i, row){
          option_value += '<option value="' + row.city_id + '">' + row.city_name + '</option>'
        })

        $this.closest( 'form' ).find( '[name="enduser[city_cd]"]' ).html( option_value );
        $this.closest( 'form' ).find( '[name="enduser[city_cd]"]' ).find( 'option[value="' + response.data.selected.city_id + '"]' ).prop('selected', true);

        // 町名設置
        var option_value = '<option value="">町名を選択してください</option>';
        $.each(response.data.area_list, function(i, row){
          option_value += '<option value="' + row.id + '">' + row.area_name + '</option>'
        })

        $this.closest( 'form' ).find( '[name="enduser[area_id]"]' ).html( option_value );
        $this.closest( 'form' ).find( '[name="enduser[area_id]"]' ).find( 'option[value="' + response.data.selected.id + '"]' ).prop('selected', true);
      } else {

      }
    });
  });

  // 郵便番号がわからない場合の処理
  $( '.form-address__find' ).click( function() {
    $( this ).hide();
    $( '.form-address__back' ).show();

    //郵便番号のボックスを非表示
    $( '#ttl_zip_cd, #mark_zip_cd, #box_zip_cd' ).css( { "opacity": 0 } );
    $( '#label_address' ).hide();
    //都道府県のボックスを表示
    $( '#box_pref, #box_city, #box_area' ).slideDown();
  });

  // 郵便番号がわからない場合の処理
  $( '.form-address__back' ).click( function() {
    $( this ).hide();
    $( '.form-address__find' ).show();

    //郵便番号のボックスを非表示
    $( '#ttl_zip_cd, #mark_zip_cd, #box_zip_cd, #label_address' ).css( { "opacity": 1 } );
    $( '#label_address' ).show();
    //都道府県のボックスを表示
    $( '#box_pref, #box_city, #box_area' ).slideUp();
  });
});


//////////////////
// WEBPACK FOOTER
// ./app/assets/javascripts/form/area.js
// module id = 5
// module chunks = 0 1